import React, { createContext, ReactNode, useMemo, useState } from 'react';
import { FISCAL_YEAR_STORAGE_KEY, getCurrentFiscalYearStart } from '../utils/fiscalYear';

interface FiscalYearContextValue {
    fiscalYear: number;
    setFiscalYear: (startYear: number) => void;
}

function getInitialFiscalYear(): number {
    const saved = Number(window.localStorage.getItem(FISCAL_YEAR_STORAGE_KEY));
    return Number.isInteger(saved) && saved >= 2024 && saved <= 2200
        ? saved
        : getCurrentFiscalYearStart();
}

export const FiscalYearContext = createContext<FiscalYearContextValue>({
    fiscalYear: getCurrentFiscalYearStart(),
    setFiscalYear: () => undefined
});

export function FiscalYearProvider({ children }: { children: ReactNode }) {
    const [fiscalYear, setFiscalYearState] = useState(getInitialFiscalYear);

    const value = useMemo(() => ({
        fiscalYear,
        setFiscalYear: (startYear: number) => {
            if (!Number.isInteger(startYear) || startYear < 2024 || startYear > 2200) return;
            window.localStorage.setItem(FISCAL_YEAR_STORAGE_KEY, String(startYear));
            setFiscalYearState(startYear);
        }
    }), [fiscalYear]);

    return <FiscalYearContext.Provider value={value}>{children}</FiscalYearContext.Provider>;
}
